import { VimeoPlayers } from '../components/VimeoPlayers';
import { onDOMContentLoaded } from '../utils/onDOMContentLoaded';

onDOMContentLoaded(() => {
  VimeoPlayers();
});
